import { render } from "./PaymentModal.vue?vue&type=template&id=0c40114d&ts=true"
import script from "./PaymentModal.vue?vue&type=script&lang=ts"
export * from "./PaymentModal.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_4ed9b393/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__